if (!window.coverGlow) {
  window.coverGlow = true;

  // Reads the main image's dominant colour from a 32x32 sample. Greys, near-blacks and near-whites
  // are skipped, so a mostly black cover with gold accents glows gold. Returns null when the image
  // has too little colour, and the page then stays plain dark.
  const dominantColour = (data) => {
    const buckets = Array.from({ length: 24 }, () => ({ weight: 0, r: 0, g: 0, b: 0 }));
    for (let i = 0; i < data.length; i += 4) {
      if (data[i + 3] < 200) continue;
      const r = data[i];
      const g = data[i + 1];
      const b = data[i + 2];
      const max = Math.max(r, g, b);
      const min = Math.min(r, g, b);
      const lightness = (max + min) / 510;
      const saturation = max === min ? 0 : (max - min) / (255 - Math.abs(max + min - 255));
      if (saturation < 0.3 || lightness < 0.15 || lightness > 0.85) continue;

      let hue;
      if (max === r) hue = ((g - b) / (max - min) + 6) % 6;
      else if (max === g) hue = (b - r) / (max - min) + 2;
      else hue = (r - g) / (max - min) + 4;

      const bucket = buckets[Math.floor(hue * 4) % 24];
      bucket.weight += saturation;
      bucket.r += r * saturation;
      bucket.g += g * saturation;
      bucket.b += b * saturation;
    }
    const best = buckets.reduce((top, bucket) => (bucket.weight > top.weight ? bucket : top));
    if (best.weight < 8) return null;
    return [best.r / best.weight, best.g / best.weight, best.b / best.weight];
  };

  // Evens out the colour so every game gets a glow of similar strength: mid lightness, capped saturation.
  const tone = ([r, g, b]) => {
    const max = Math.max(r, g, b) / 255;
    const min = Math.min(r, g, b) / 255;
    let hue = 0;
    if (max !== min) {
      const d = max - min;
      if (max === r / 255) hue = ((g - b) / 255 / d + 6) % 6;
      else if (max === g / 255) hue = (b - r) / 255 / d + 2;
      else hue = (r - g) / 255 / d + 4;
    }
    const l = Math.min(Math.max((max + min) / 2, 0.45), 0.6);
    const s = Math.min(max === min ? 0 : (max - min) / (1 - Math.abs(max + min - 1)), 0.85);
    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs((hue % 2) - 1));
    const m = l - c / 2;
    const [r1, g1, b1] = [[c, x, 0], [x, c, 0], [0, c, x], [0, x, c], [x, 0, c], [c, 0, x]][Math.floor(hue) % 6];
    return `rgb(${Math.round((r1 + m) * 255)} ${Math.round((g1 + m) * 255)} ${Math.round((b1 + m) * 255)})`;
  };

  const apply = (glow, colour) => {
    glow.style.setProperty('--cover-glow-color', colour);
    glow.classList.add('is-ready');
  };

  const readStored = (key) => {
    try {
      return sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  };

  const store = (key, value) => {
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {
      // Storage can be unavailable (private mode); the colour is simply worked out again next time.
    }
  };

  const setUpGlows = () => {
    document.querySelectorAll('.cover-glow[data-cover-glow-src]:not(.is-ready)').forEach((glow) => {
      const src = glow.dataset.coverGlowSrc;
      const key = `cover-glow:${src}`;

      // Seen this image already in this visit: show the glow straight away, no fade.
      const stored = readStored(key);
      if (stored) {
        if (stored !== 'none') {
          glow.classList.add('is-instant');
          apply(glow, stored);
        }
        return;
      }

      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.decoding = 'async';
      image.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = 32;
          canvas.height = 32;
          const context = canvas.getContext('2d', { willReadFrequently: true });
          context.drawImage(image, 0, 0, 32, 32);
          const colour = dominantColour(context.getImageData(0, 0, 32, 32).data);
          const toned = colour ? tone(colour) : 'none';
          store(key, toned);
          if (colour) apply(glow, toned);
        } catch (error) {
          // The image could not be read (e.g. blocked by the browser); the page stays plain dark.
        }
      };
      image.src = src;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setUpGlows);
  } else {
    setUpGlows();
  }
  document.addEventListener('shopify:section:load', setUpGlows);
}
